import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=4327422b&scoped=true"
import script from "./RequestList.vue?vue&type=script&lang=js"
export * from "./RequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4327422b",
  null
  
)

export default component.exports